var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',[(_vm.id > 0)?_c('h1',[_vm._v("Modification de la demande #"+_vm._s(_vm.id))]):_c('h1',[_vm._v("Nouvelle demande")]),_c('demande-main')],1)}
var staticRenderFns = []

export { render, staticRenderFns }